<template>
  <div class="home-container">
    <!-- Header -->
    <headerSection />

    <!-- Running Text Announcement -->
    <RunningText 
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Desktop Layout -->
    <div class="d-none d-lg-block desktop-layout">
      <!-- Left Sidebar -->
      <LeftSidebar 
        :leftMenuItems="leftMenuItems" 
        :hoveredIndex="hoveredLeftIndex"
        :user="user"
        @menu-enter="onLeftMenuEnter"
        @menu-leave="onLeftMenuLeave"
      />

      <!-- Main Content -->
      <div class="main-content">
        <!-- Banner Section - Above Main Menu -->
        <div class="banner-section" v-if="banners && banners.length > 0">
          <div class="swiper-loading" v-if="!banners || banners.length === 0">
            <div class="loading-spinner"></div>
            <span>Loading banners...</span>
          </div>
          <swiper
                ref="mySwiper"
                :options="swiperOptions"
                style="padding-top:10px;padding-left:10px;padding-right:10px;"
              >
                <swiper-slide v-for="(item,index) in banners" :key="index">
                  <img
                    style="margin: auto;width: 650px;border-radius: 15px;"
                    class="img-fluid -slick-item -item-1"
                    :alt="item.name"
                    width="650"
                    :src="item.image"
                /></swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              </swiper>
        </div>

        <!-- Main Menu Bar -->
        <MainMenuBar 
          :mainMenuItems="mainMenuItems" 
          :hoveredIndex="hoveredMainIndex"
          :user="user"
          @menu-enter="onMainMenuEnter"
          @menu-leave="onMainMenuLeave"
        />

        <!-- Content Sections -->
        <div class="content-sections">
          <!-- Jackpot Games Section -->
          <div class="jackpot-games-container animated fadeInUp" data-animatable="fadeInUp" data-delay="100">
            <h2 class="section-title">Jackpot Games</h2>
            <div class="games-grid">
              <!-- Jackpot Game Cards -->
              <div v-for="(item, index) in jackpots" :key="item.key || `${item.provider}-${item.id}`" :class="{'game-card': true, 'jackpot-card': true, 'first-game': index === 0}">
                <div class="card-inner" v-if="item.image && item.image.horizontal">
                  <!-- Jackpot Badge -->
                  <div class="game-badge jackpot-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="300">
                    <span>Jackpot</span>
                  </div>
                  
                  <!-- Game Image -->
                  <div class="game-image">
                    <template v-if="isLoggedIn">
                      <router-link :to="{ name: 'PlayGame', query: {id: item.id, provider: item.provider, gameCategory: item.gameCategory}}" 
                                   target="_blank" class="game-link">
                        <img :src="item.image.horizontal" :alt="item.gameName" class="cover-img">
                      </router-link>
                    </template>
                    <template v-else>
                      <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                        <img :src="item.image.horizontal" :alt="item.gameName" class="cover-img">
                      </a>
                    </template>
                  </div>

                  <!-- Jackpot Amount -->
                  <div class="jackpot-amount">
                    ${{ Math.round(item.jackpot).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                  </div>

                  <!-- Game Overlay -->
                  <div class="game-overlay">
                    <div class="overlay-inner">
                      <div class="wrapper-container">
                        <template v-if="isLoggedIn">
                          <router-link :to="{ name: 'PlayGame', query: {id: item.id, provider: item.provider, gameCategory: item.gameCategory}}" 
                                       target="_blank" class="play-btn">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </router-link>
                        </template>
                        <template v-else>
                          <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </a>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Popular Games Section -->
          <div class="popular-games-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
            <h2 class="section-title">เกมส์ยอดนิยม</h2>
            <div class="games-grid">
              <!-- Game Cards -->
              <div v-for="(game, index) in hotgames" :key="game.id"
                   :class="{'game-card': true, 'first-game': index === 0}">
                <div class="card-inner" v-if="game.image && game.image.vertical">
                  <!-- Hot Badge -->
                  <div class="game-badge hot-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="400">
                    <span>Hot</span>
                  </div>
                  
                  <!-- Game Image -->
                  <div class="game-image">
                    <template v-if="isLoggedIn">
                      <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" 
                                   target="_blank" class="game-link">
                        <img :src="game.image.vertical" :alt="game.gameName" 
                             class="cover-img" width="216" height="216">
                      </router-link>
                    </template>
                    <template v-else>
                      <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                        <img :src="game.image.vertical" :alt="game.gameName" 
                             class="cover-img" width="216" height="216">
                      </a>
                    </template>
                  </div>

                  <!-- Game Overlay -->
                  <div class="game-overlay">
                    <div class="overlay-inner">
                      <div class="wrapper-container">
                        <template v-if="isLoggedIn">
                          <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" 
                                       target="_blank" class="play-btn">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </router-link>
                        </template>
                        <template v-else>
                          <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </a>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Info Card (Desktop only) -->
              <!-- <div class="game-card info-card d-none d-lg-block">
                <div class="card-inner">
                  <div class="card-image" v-if="hotgames && hotgames.length > 0">
                    <img :src="(hotgames[0].image && hotgames[0].image.vertical) || ''" 
                         alt="Popular Info" class="cover-img">
                  </div>
                  <div class="card-overlay">
                    <h3 class="card-title">รวมเกมแตกบ่อย สล็อตออนไลน์ยอดฮิต</h3>
                    <ul class="feature-list">
                      <li><span>อัตราจ่ายสูง</span></li>
                      <li><span>โบนัสแตกง่าย</span></li>
                      <li><span>ภาพและเสียงสนุก</span></li>
                      <li><span>เล่นได้ทุกที่ 24 ชม.</span></li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Slot Brands Section -->
          <div class="slot-brands-container animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
            <h2 class="section-title">สล็อตยอดนิยม</h2>
            <div class="games-grid">
              <!-- Slot Brand Cards -->
              <div v-for="(slot, index) in slotbrands" :key="slot.provider" 
                   :class="{'game-card': true, 'slot-brand-card': true, 'first-game': index === 0}">
                <div class="card-inner" v-if="slot.askmepage && slot.askmepage.default">
                  <!-- Slot Badge -->
                  <!-- <div class="game-badge slot-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                    <span>Slot</span>
                  </div> -->
                  
                  <!-- Slot Brand Image -->
                  <div class="game-image">
                    <template v-if="isLoggedIn">
                      <router-link :to="slotProviderRoute(slot)" 
                                   class="game-link">
                        <img :src="slot.askmepage.default" :alt="slot.provider" 
                             class="cover-img" width="250" height="250">
                      </router-link>
                    </template>
                    <template v-else>
                      <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                        <img :src="slot.askmepage.default" :alt="slot.provider" 
                             class="cover-img" width="250" height="250">
                      </a>
                    </template>
                  </div>

                  <!-- Game Overlay -->
                  <div class="game-overlay">
                    <div class="overlay-inner">
                      <div class="wrapper-container">
                        <template v-if="isLoggedIn">
                          <router-link :to="slotProviderRoute(slot)" 
                                       class="play-btn">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </router-link>
                        </template>
                        <template v-else>
                          <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </a>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Casino Brands Section -->
          <div class="casino-brands-container animated fadeInUp" data-animatable="fadeInUp" data-delay="250">
            <h2 class="section-title">คาสิโนออนไลน์ ยอดนิยม</h2>
            <div class="games-grid">
              <!-- Casino Brand Cards -->
              <div v-for="(casino, index) in casinos" :key="casino.provider" 
                   :class="{'game-card': true, 'casino-brand-card': true, 'first-game': index === 0}">
                <div class="card-inner" v-if="casino.askmepage && casino.askmepage.default">
                  <!-- Casino Badge -->
                  <div class="game-badge casino-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="600">
                    <span>Casino</span>
                  </div>
                  
                  <!-- Casino Brand Image -->
                  <div class="game-image">
                    <template v-if="isLoggedIn">
                      <router-link :to="casinoProviderRoute(casino)" 
                                   class="game-link">
                        <img :src="casino.askmepage.default" :alt="casino.provider" 
                             class="cover-img" width="250" height="250">
                      </router-link>
                    </template>
                    <template v-else>
                      <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                        <img :src="casino.askmepage.default" :alt="casino.provider" 
                             class="cover-img" width="250" height="250">
                      </a>
                    </template>
                  </div>

                  <!-- Game Overlay -->
                  <div class="game-overlay">
                    <div class="overlay-inner">
                      <div class="wrapper-container">
                        <template v-if="isLoggedIn">
                          <router-link :to="casinoProviderRoute(casino)" 
                                       class="play-btn">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </router-link>
                        </template>
                        <template v-else>
                          <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                            <i class="fas fa-play"></i>
                            <span class="btn-text">เข้าเล่น</span>
                          </a>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Mobile Layout -->
    <div class="d-block d-lg-none mobile-layout">
      <!-- Banner Section - Above Main Menu -->
      <div class="banner-section" v-if="banners && banners.length > 0">
        <div class="swiper-loading" v-if="!banners || banners.length === 0">
          <div class="loading-spinner"></div>
          <span>Loading banners...</span>
        </div>
        <Swiper :options="swiperOptions" class="mobile-swiper">
          <SwiperSlide v-for="(item, index) in banners" :key="index">
            <div class="image-container">
              <!-- Actual Image -->
              <img
                class="img-fluid banner-image"
                :alt="item.name"
                width="1200"
                height="200"
                :src="getCachedImageUrl(item.image)"
                @load="onImageLoad"
                @error="onImageError"
              />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <!-- Mobile Main Menu -->
      <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

      <!-- Mobile With Sidebar Layout -->
      <div class="mobile-with-sidebar">
        <!-- Mobile Left Sidebar -->
        <MobileLeftSidebar 
          :leftMenuItems="leftMenuItems" 
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Mobile Content Area -->
        <div class="mobile-content-area">
          <!-- Content Sections -->
          <div class="content-sections">
            <!-- Jackpot Games Section -->
            <div class="jackpot-games-container animated fadeInUp" data-animatable="fadeInUp" data-delay="100">
              <h2 class="section-title">Jackpot Games</h2>
              <div class="games-grid">
                <!-- Jackpot Game Cards -->
                <div v-for="(item, index) in jackpots" :key="item.key || `${item.provider}-${item.id}`" :class="{'game-card': true, 'jackpot-card': true, 'first-game': index === 0}">
                  <div class="card-inner" v-if="item.image && item.image.horizontal">
                    <!-- Jackpot Badge -->
                    <div class="game-badge jackpot-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="300">
                      <span>Jackpot</span>
                    </div>
                    
                    <!-- Game Image -->
                    <div class="game-image">
                      <template v-if="isLoggedIn">
                        <router-link :to="{ name: 'PlayGame', query: {id: item.id, provider: item.provider, gameCategory: item.gameCategory}}" 
                                     target="_blank" class="game-link">
                          <img :src="item.image.horizontal" :alt="item.gameName" class="cover-img">
                        </router-link>
                      </template>
                      <template v-else>
                        <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                          <img :src="item.image.horizontal" :alt="item.gameName" class="cover-img">
                        </a>
                      </template>
                    </div>

                    <!-- Jackpot Amount -->
                    <div class="jackpot-amount">
                      ${{ Math.round(item.jackpot).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                    </div>

                    <!-- Game Overlay -->
                    <div class="game-overlay">
                      <div class="overlay-inner">
                        <div class="wrapper-container">
                          <template v-if="isLoggedIn">
                            <router-link :to="{ name: 'PlayGame', query: {id: item.id, provider: item.provider, gameCategory: item.gameCategory}}" 
                                         target="_blank" class="play-btn">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </router-link>
                          </template>
                          <template v-else>
                            <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Popular Games Section -->
            <div class="popular-games-container animated fadeInUp" data-animatable="fadeInUp" data-delay="150">
              <h2 class="section-title">เกมส์ยอดนิยม</h2>
              <div class="games-grid">
                <!-- Game Cards -->
                <div v-for="(game, index) in hotgames" :key="game.id"
                     :class="{'game-card': true, 'first-game': index === 0}">
                  <div class="card-inner" v-if="game.image && game.image.vertical">
                    <!-- Hot Badge -->
                    <div class="game-badge hot-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="400">
                      <span>Hot</span>
                    </div>
                    
                    <!-- Game Image -->
                    <div class="game-image">
                      <template v-if="isLoggedIn">
                        <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" 
                                     target="_blank" class="game-link">
                          <img :src="game.image.vertical" :alt="game.gameName" 
                               class="cover-img" width="216" height="216">
                        </router-link>
                      </template>
                      <template v-else>
                        <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                          <img :src="game.image.vertical" :alt="game.gameName" 
                               class="cover-img" width="216" height="216">
                        </a>
                      </template>
                    </div>

                    <!-- Game Overlay -->
                    <div class="game-overlay">
                      <div class="overlay-inner">
                        <div class="wrapper-container">
                          <template v-if="isLoggedIn">
                            <router-link :to="{ name: 'PlayGame', query: {id: game.id, provider: game.provider, gameCategory: game.gameCategory}}" 
                                         target="_blank" class="play-btn">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </router-link>
                          </template>
                          <template v-else>
                            <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Slot Brands Section -->
            <div class="slot-brands-container animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
              <h2 class="section-title">สล็อตยอดนิยม</h2>
              <div class="games-grid">
                <!-- Slot Brand Cards -->
                <div v-for="(slot, index) in slotbrands" :key="slot.provider" 
                     :class="{'game-card': true, 'slot-brand-card': true, 'first-game': index === 0}">
                  <div class="card-inner" v-if="slot.askmepage && slot.askmepage.default">
                    <!-- Slot Brand Image -->
                    <div class="game-image">
                      <template v-if="isLoggedIn">
                        <router-link :to="slotProviderRoute(slot)" 
                                     class="game-link">
                          <img :src="slot.askmepage.default" :alt="slot.provider" 
                               class="cover-img" width="250" height="250">
                        </router-link>
                      </template>
                      <template v-else>
                        <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                          <img :src="slot.askmepage.default" :alt="slot.provider" 
                               class="cover-img" width="250" height="250">
                        </a>
                      </template>
                    </div>

                    <!-- Game Overlay -->
                    <div class="game-overlay">
                      <div class="overlay-inner">
                        <div class="wrapper-container">
                          <template v-if="isLoggedIn">
                            <router-link :to="slotProviderRoute(slot)" 
                                         class="play-btn">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </router-link>
                          </template>
                          <template v-else>
                            <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Casino Brands Section -->
            <div class="casino-brands-container animated fadeInUp" data-animatable="fadeInUp" data-delay="250">
              <h2 class="section-title">คาสิโนออนไลน์ ยอดนิยม</h2>
              <div class="games-grid">
                <!-- Casino Brand Cards -->
                <div v-for="(casino, index) in casinos" :key="casino.provider" 
                     :class="{'game-card': true, 'casino-brand-card': true, 'first-game': index === 0}">
                  <div class="card-inner" v-if="casino.askmepage && casino.askmepage.default">
                    <!-- Casino Badge -->
                    <div class="game-badge casino-badge animated fadeInUp" data-animatable="fadeInUp" data-delay="600">
                      <span>Casino</span>
                    </div>
                    
                    <!-- Casino Brand Image -->
                    <div class="game-image">
                      <template v-if="isLoggedIn">
                        <router-link :to="casinoProviderRoute(casino)" 
                                     class="game-link">
                          <img :src="casino.askmepage.default" :alt="casino.provider" 
                               class="cover-img" width="250" height="250">
                        </router-link>
                      </template>
                      <template v-else>
                        <a href="#loginModal" class="game-link" data-toggle="modal" data-target="#loginModal">
                          <img :src="casino.askmepage.default" :alt="casino.provider" 
                               class="cover-img" width="250" height="250">
                        </a>
                      </template>
                    </div>

                    <!-- Game Overlay -->
                    <div class="game-overlay">
                      <div class="overlay-inner">
                        <div class="wrapper-container">
                          <template v-if="isLoggedIn">
                            <router-link :to="casinoProviderRoute(casino)" 
                                         class="play-btn">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </router-link>
                          </template>
                          <template v-else>
                            <a href="#loginModal" class="play-btn" data-toggle="modal" data-target="#loginModal">
                              <i class="fas fa-play"></i>
                              <span class="btn-text">เข้าเล่น</span>
                            </a>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-sections" style="height: 100px;">&nbsp;</div>
        </div>
      </div>
    </div>
    <div
        class="x-modal modal  "
        id="ads-no-show-again"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-loading-container=".js-modal-content"
        data-ajax-modal-always-reload="true"
        data-modal-one-time="Announcement Banner 1"
        data-check-target="#ads-no-show-again"
      >
        <div class="modal-dialog -modal-size " role="document">
          <div class="modal-content -modal-content">
            <button
              type="button"
              class="close f-1 "
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </button>
            <div class="modal-header -modal-header">
              <h3 class="x-title-modal d-inline-block m-auto">
                <span>📢 ประกาศสำคัญ</span>
              </h3>
            </div>
            <div class="modal-body -modal-body">
              <div class="text-center" v-if="anoucement.image">
                <img
                  :src="anoucement.image"
                  alt="Announcement funbeyond"
                  class="img-fluid"
                  width="350px"
                />
              </div>
              <br>
              <div v-html="nl2br(anoucement.detail)" style="font-size:15px;font-family: 'Kanit', sans-serif;"></div>
              <div class="x-checkbox-primary">
                <div class="text-primary text-center mt-4">
                  <input
                    id="ads-no-show-again-checkbox"
                    type="checkbox"
                    v-model="receiveAnounceMent"
                  />&nbsp;&nbsp;&nbsp;&nbsp;
                  <label for="ads-no-show-again-checkbox" style="font-size:14px;font-family: 'Kanit', sans-serif;">
                    ไม่ต้องแสดงข้อความนี้อีก
                  </label>
                </div>
              </div>

              <div class="my-3">
                <a
                  @click="submitAnoucement()"
                  data-dismiss="modal"
                  class="text-black btn btn-block -submit btn-primary text-center m-auto"
                >
                  <span>รับทราบ</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Footer -->
    <div class="footer-container">
      <footerSection />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue'),
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      continueCheck: false,
      partner: false,
      cashback: false,
      roulet: false,
      spin: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      swiperOptions: {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        // ปิด lazy loading และปรับ preload
        lazy: false,
        preloadImages: true,
        updateOnImagesReady: true,
        // เพิ่ม cache และ keep slides - ปรับให้ preload ทุกรูป
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 'auto',
        // Force preload ทุก slide
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        loopedSlides: null, // จะตั้งใน mounted
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      imageCache: new Map(), // เพิ่ม image cache
      cacheKey: 'phenix_banner_cache',
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    isLoggedIn () {
      return this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
    },
    banners () {
      return this.$store.state.user.banners
    },
    slips () {
      return this.$store.state.user.slips
    },
    casinos () {
      return this.$store.state.user.casinoGames
    },
    slotbrands () {
      return this.$store.state.user.slotbrands
    },
    jackpots () {
      const games = this.$store.state.user.jackpot || []
      // Firestore docs use random ids, while launch depends on the real game id + provider pair.
      const uniqueGames = games.filter((game, index, arr) =>
        arr.findIndex(g => (g.key || `${g.provider}-${g.id}`) === (game.key || `${game.provider}-${game.id}`)) === index
      )
      return uniqueGames
    },
    cacheStatus () {
      return {
        size: this.imageCache.size,
        entries: Array.from(this.imageCache.entries())
      }
    },
    hotgames () {
      const games = this.$store.state.user.hotGames || []
      // Filter out duplicates based on game.id
      const uniqueGames = games.filter((game, index, arr) =>
        arr.findIndex(g => g.id === game.id) === index
      )
      return uniqueGames
    }
  },
  mounted () {
    // Load cache จาก localStorage
    this.loadCacheFromStorage()

    // Clear old cache entries ก่อน
    this.clearOldCacheEntries()

    this.$store.dispatch('user/getBanners')
      .then(() => {
        // ตั้งค่า loopedSlides ให้เท่ากับจำนวน banners
        if (this.banners && this.banners.length > 0) {
          this.swiperOptions.loopedSlides = this.banners.length
          // console.log('🔧 ตั้งค่า loopedSlides:', this.banners.length)
        }

        // Preload ALL banner images for caching
        this.preloadBannerImages()
        
        // Preload main menu hover images
        this.preloadMainMenuImages()

        // Debug: แสดงสถานะ cache หลังจาก preload
        setTimeout(() => {
          this.logCacheStatus()
        }, 3000)

        // เพิ่ม global debug methods
        if (typeof window !== 'undefined') {
          window.checkImageCache = () => this.logCacheStatus()
          window.forceCacheImages = () => this.forceCacheAllImages()
          window.clearImageCache = () => {
            this.imageCache.clear()
            localStorage.removeItem(this.cacheKey)
            // console.log('🧹 ลบ cache ทั้งหมดแล้ว')
          }

          // console.log('🛠️ Debug methods พร้อมใช้:')
          // console.log('  - window.checkImageCache() - ตรวจสอบสถานะ cache')
          // console.log('  - window.forceCacheImages() - โหลดรูปทั้งหมดใหม่')
          // console.log('  - window.clearImageCache() - ลบ cache ทั้งหมด')
          // console.log('')
          // console.log('💡 วิธีแก้ปัญหารูปที่ 5-6:')
          // console.log('  1. เรียก window.checkImageCache() เพื่อดูสถานะ')
          // console.log('  2. หากรูปบางรูปไม่มีใน cache ให้เรียก window.forceCacheImages()')
          // console.log('  3. หากยังมีปัญหาให้เรียก window.clearImageCache() แล้วรอ preload ใหม่')
        }
      })
      .catch(err => { console.error(err) })

    this.checkAnoucement()
    this.$store.dispatch('user/getSlips').catch(err => { console.error(err) })
    this.$store.dispatch('user/getJackpotGames').catch(err => { console.error(err) })
    this.$store.dispatch('user/getGames', { user: this.user }).catch(err => { console.error(err) })
  },
  beforeDestroy () {
    // ไม่ต้องลบ cache เพราะเราต้องการ persist มัน
    // this.imageCache.clear()
  },
  methods: {
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
      }
    },
    onImageLoad (event) {
      const imageUrl = event.target.src
      const cleanUrl = imageUrl.split('?')[0].split('#')[0]

      // บันทึกรูปที่โหลดสำเร็จใน cache
      this.imageCache.set(cleanUrl, {
        loaded: true,
        url: imageUrl,
        timestamp: Date.now()
      })

      // console.log('🎯 บันทึกรูปที่โหลดสำเร็จ:', cleanUrl)

      // บันทึกลงใน localStorage
      this.saveCacheToStorage()

      event.target.classList.add('loaded')
      const container = event.target.closest('.image-container')
      if (container) {
        container.classList.add('loaded')
      }
    },
    onImageError (event) {
      console.warn('Banner image failed to load:', event.target.src)

      // Hide loading placeholder and show error state
      const container = event.target.closest('.image-container')
      if (container) {
        const placeholder = container.querySelector('.image-loading-placeholder')
        if (placeholder) {
          placeholder.style.opacity = '0'
          placeholder.style.pointerEvents = 'none'

          // Show error message
          const errorDiv = document.createElement('div')
          errorDiv.className = 'image-error'
          errorDiv.textContent = 'Failed to load'
          errorDiv.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #ff6b6b; font-size: 14px;'
          container.appendChild(errorDiv)
        }
      }
    },
    decodeHtml (str, isXhtml) {
      if (str && typeof str === 'string') {
        const replaceMap = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&#39;': "'",
          '&quot;': '"'
        }

        for (const key in replaceMap) {
          str = str.replace(new RegExp(key, 'g'), replaceMap[key])
        }
      }
      return str
    },
    async checkAnoucement () {
      const user = this.getUserId()
      if (!user || !user.key) {
        return
      }

      const anoucement = (await firebase.database().ref('/anoucement/1').once('value')).val()
      if (anoucement && anoucement.status) {
        if (!anoucement.users || !anoucement.users[user.key]) {
          this.anoucement = anoucement
          $('#ads-no-show-again').modal('show')
        }
      }
    },
    async submitAnoucement () {
      if (!this.receiveAnounceMent) {
        return
      }

      const user = this.getUserId()
      if (!user || !user.key) {
        return
      }

      await firebase.database().ref(`/anoucement/1/users/${user.key}`).set(true)
    },
    gameLen (games) {
      let len = 0
      for (const x in games) {
        len += games[x].games.length
      }
      return len
    },
    preloadBannerImages () {
      // Preload ALL banner images และเก็บใน cache
      if (this.banners && this.banners.length > 0) {
        // console.log(`🚀 เริ่ม preload banners จำนวน: ${this.banners.length} รูป`)
        // console.log('📋 รายการ banners:')

        let loadedCount = 0
        let totalCount = 0

        this.banners.forEach((banner, index) => {
          if (banner.image) {
            totalCount++
            const cleanUrl = banner.image.split('?')[0].split('#')[0]

            if (!this.imageCache.has(cleanUrl)) {
              //console.log(`📥 [${index + 1}/${this.banners.length}] กำลังโหลด:`, cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1))

              const img = new Image()
              img.onload = () => {
                loadedCount++
                this.imageCache.set(cleanUrl, {
                  loaded: true,
                  url: banner.image,
                  timestamp: Date.now()
                })
                // console.log(`✅ [${loadedCount}/${totalCount}] โหลดสำเร็จ:`, cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1))
                // บันทึกลงใน localStorage เมื่อโหลดเสร็จ
                this.saveCacheToStorage()

                // แจ้งเตือนเมื่อโหลดครบ
                // if (loadedCount === totalCount) {
                //   console.log('🎉 โหลดรูปครบทั้งหมดแล้ว!', loadedCount, 'รูป')
                // }
              }
              img.onerror = () => {
                this.imageCache.set(cleanUrl, {
                  loaded: false,
                  url: banner.image,
                  timestamp: Date.now()
                })
                // console.error(`❌ [${index + 1}/${this.banners.length}] โหลดไม่ได้:`, cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1))
                // บันทึกลงใน localStorage แม้ว่าจะโหลดไม่ได้
                this.saveCacheToStorage()
              }
              img.src = banner.image
            } else {
              loadedCount++
              //console.log(`♻️ [${index + 1}/${this.banners.length}] มีใน cache แล้ว:`, cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1))
            }
          }
        })

        // แจ้งเตือนสรุป
        //console.log(`📊 สรุป: จะโหลดรูปทั้งหมด ${totalCount} รูป (${loadedCount} รูปมีใน cache แล้ว)`)
      } else {
        console.warn('⚠️ ไม่มี banners ให้ preload')
      }
    },
    getCachedImageUrl (imageUrl) {
      // ลบ query parameters และ fragments เพื่อให้ cache URL ได้ดีขึ้น
      const cleanUrl = imageUrl.split('?')[0].split('#')[0]

      if (this.imageCache.has(cleanUrl)) {
        const cached = this.imageCache.get(cleanUrl)
        if (cached.loaded) {
          //console.log('✅ รูปภาพโหลดจาก cache:', cleanUrl)
          return cached.url
        } else {
          //console.log('❌ รูปภาพใน cache แต่โหลดไม่ได้:', cleanUrl)
        }
      } else {
        //console.log('🔄 รูปภาพใหม่ กำลังโหลด:', cleanUrl)
      }
      return imageUrl
    },
    clearOldCacheEntries () {
      // ลบ cache entries ที่เก่าเกิน 1 ชั่วโมง
      const oneHour = 60 * 60 * 1000
      const now = Date.now()

      for (const [key, value] of this.imageCache.entries()) {
        if (now - value.timestamp > oneHour) {
          this.imageCache.delete(key)
        }
      }

      // บันทึกกลับไปยัง localStorage
      this.saveCacheToStorage()
    },
    loadCacheFromStorage () {
      try {
        const cachedData = localStorage.getItem(this.cacheKey)
        if (cachedData) {
          const parsed = JSON.parse(cachedData)
          // แปลง object กลับเป็น Map
          this.imageCache = new Map(Object.entries(parsed))
          //console.log('📥 โหลด image cache จาก localStorage:', this.imageCache.size, 'รายการ')
        } else {
          //console.log('📭 ไม่มี cache ใน localStorage')
        }
      } catch (error) {
        //console.warn('ไม่สามารถโหลด image cache จาก localStorage:', error)
        this.imageCache = new Map()
      }
    },
    saveCacheToStorage () {
      try {
        // แปลง Map เป็น object เพื่อ stringify
        const cacheObject = Object.fromEntries(this.imageCache)
        localStorage.setItem(this.cacheKey, JSON.stringify(cacheObject))
        //console.log('💾 บันทึก image cache ลงใน localStorage:', this.imageCache.size, 'รายการ')
      } catch (error) {
        console.warn('ไม่สามารถบันทึก image cache ไปยัง localStorage:', error)
      }
    },
    // Debug method สำหรับตรวจสอบ cache
    logCacheStatus () {
      // console.log('🔍 Cache Status:')
      // console.log('- ขนาด cache:', this.imageCache.size)
      // console.log('- จำนวน banners:', this.banners?.length || 0)
      // console.log('- รายการ cache:')
      // for (const [url, data] of this.imageCache.entries()) {
      //   console.log(`  ${data.loaded ? '✅' : '❌'} ${url}`)
      // }

      // ตรวจสอบว่า cache ครบทุกรูปไหม
      if (this.banners && this.banners.length > 0) {
        const missingImages = this.banners.filter((banner) => {
          if (!banner.image) return false
          const cleanUrl = banner.image.split('?')[0].split('#')[0]
          return !this.imageCache.has(cleanUrl) || !this.imageCache.get(cleanUrl).loaded
        })

        if (missingImages.length > 0) {
          //console.warn('⚠️ รูปที่ยังไม่ได้ cache:', missingImages.length, 'รูป')
          missingImages.forEach((banner, index) => {
            console.warn(`  🔴 รูปที่ยังขาด ${index + 1}:`, banner.image)
          })
        } else {
          //console.log('🎉 Cache ครบทุกรูปแล้ว!')
        }
      }
    },
    // Force cache ทุกรูปอีกครั้ง
    forceCacheAllImages () {
      console.log('🔧 Force cache ทุกรูปอีกครั้ง...')
      if (this.banners && this.banners.length > 0) {
        this.banners.forEach((banner, index) => {
          if (banner.image) {
            const cleanUrl = banner.image.split('?')[0].split('#')[0]

            // ลบออกจาก cache ก่อนแล้วโหลดใหม่
            if (this.imageCache.has(cleanUrl)) {
              this.imageCache.delete(cleanUrl)
            }

            console.log(`🔄 Force reload รูปที่ ${index + 1}:`, cleanUrl)
            const img = new Image()
            img.onload = () => {
              this.imageCache.set(cleanUrl, {
                loaded: true,
                url: banner.image,
                timestamp: Date.now()
              })
              console.log(`✅ Force reload สำเร็จรูปที่ ${index + 1}:`, cleanUrl)
              this.saveCacheToStorage()
            }
            img.onerror = () => {
              console.error(`❌ Force reload ไม่ได้รูปที่ ${index + 1}:`, cleanUrl)
            }
            img.src = banner.image + '?t=' + Date.now() // เพิ่ม timestamp เพื่อ bypass cache
          }
        })
      }
    },
    // Left menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    // Preload main menu hover images
    preloadMainMenuImages () {
      if (this.mainMenuItems && this.mainMenuItems.length > 0) {
        this.mainMenuItems.forEach((item, index) => {
          if (item.hoverIcon) {
            const img = new Image()
            img.src = item.hoverIcon
          }
        })
      }
    },
    // Main menu hover methods
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    slotProviderRoute (slot) {
      return {
        path: '/main',
        query: {
          type: 'slot',
          band: slot.key || slot.provider
        }
      }
    },
    casinoProviderRoute (casino) {
      return {
        path: '/main',
        query: {
          type: 'casino',
          provider: casino.provider
        }
      }
    },
    // Game play methods
    playGame (id, provider, gameCategory) {
      // Navigate to play game route
      this.$router.push({
        name: 'PlayGame',
        query: {
          id: id,
          provider: provider,
          gameCategory: gameCategory
        }
      })
    }
  }
}
</script>

<style scoped>
/* Base Styles */
.home-container {
  background-color: #232323;
  color: #ffffff;
  min-height: 100vh;
  position: relative;
}


/* Desktop Styles */
.desktop-layout {
  display: flex;
  min-height: 100vh;
}


.main-content {
  margin-left: 100px;
  padding-top: 105px;
  width: calc(100% - 100px);
  min-height: 100vh;
  background-image: url('../assets/images/background/desktop.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.banner-section {
  margin-bottom: 20px;
}

.main-swiper {
  width: 100%;
  height: 250px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}


/* Popular Games Section */
.popular-games-container {
  /* margin-bottom: 40px;
  padding: 0 15px; */
}

.games-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  margin-top: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px 0;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* Custom scrollbar for games grid */
.games-grid::-webkit-scrollbar {
  display: none;
}

.game-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  flex: 0 0 200px;
  min-width: 200px;
  max-width: 200px;
}

.jackpot-card {
  flex: 0 0 300px;
  min-width: 300px;
  max-width: 300px;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.heading-card .card-inner,
.info-card .card-inner {
  height: 320px;
}

.card-image,
.game-image {
  width: 100%;
  height: 100%;
  position: relative;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.card-overlay,
.game-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 12px;
}

.heading-card .card-overlay,
.info-card .card-overlay {
  opacity: 1;
  background: rgba(27, 27, 65, 0.9);
}

.game-card:hover .game-overlay {
  opacity: 1;
}

.games-count {
  color: #ffc107;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.card-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 15px;
}

.see-more-btn {
  background: linear-gradient(145deg, #ffc107, #ff8c00);
  color: #1b1b41;
  padding: 8px 20px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.see-more-btn:hover {
  background: linear-gradient(145deg, #ff8c00, #ffc107);
  color: #1b1b41;
  text-decoration: none;
  transform: scale(1.05);
}

.game-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: linear-gradient(145deg, #ff4757, #ff3838);
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 700;
  z-index: 10;
}

.jackpot-badge {
  background: linear-gradient(145deg, #ffd700, #ffb700);
  color: #1b1b41;
}

.slot-badge {
  background: linear-gradient(145deg, #9b59b6, #8e44ad);
  color: #ffffff;
}

.casino-badge {
  background: linear-gradient(145deg, #e74c3c, #c0392b);
  color: #ffffff;
}

.slot-brand-card {
  flex: 0 0 250px;
  min-width: 250px;
  max-width: 250px;
}

.casino-brand-card {
  flex: 0 0 250px;
  min-width: 250px;
  max-width: 250px;
}

.jackpot-amount {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: #ffd700;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  z-index: 10;
  border: 1px solid #ffd700;
  min-width: 80px;
  text-align: center;
}

.play-btn {
  background: linear-gradient(145deg, #ffc107, #ff8c00);
  color: #1b1b41;
  padding: 12px 24px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.play-btn:hover {
  background: linear-gradient(145deg, #ff8c00, #ffc107);
  color: #1b1b41;
  text-decoration: none;
  transform: scale(1.05);
}

.game-title {
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  padding: 0 10px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  color: #ffffff;
  margin-bottom: 8px;
  position: relative;
  padding-left: 20px;
}

.feature-list li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #ffc107;
  font-weight: bold;
}

.game-link {
  display: block;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .games-grid {
    gap: 15px;
  }
  
  .game-card {
    flex: 0 0 150px;
    min-width: 150px;
    max-width: 150px;
  }
  .jackpot-card {
    flex: 0 0 150px;
    min-width: 150px;
    max-width: 150px;
  }
  
  .jackpot-card .game-image img {
    height: auto;
    object-fit: contain;
  }
  .card-inner {
    /* height: 200px; */
  }
  
  .card-title {
    font-size: 16px;
  }
  
  .game-title {
    font-size: 12px;
  }
}

/* Mobile Styles */
.mobile-layout {
  padding-top: 105px;
  min-height: 100vh;
  background-image: url('../assets/images/background/mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.mobile-swiper {
  width: 100%;
  /* height: 200px; */
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 15px;
}


.mobile-with-sidebar {
  display: flex;
  min-height: calc(100vh - 300px);
}


.mobile-content-area {
  flex: 1;
  /* padding: 0 15px; */
  overflow-y: auto;
}


/* Banner Image Styles */
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
}

.banner-image {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.banner-image.loaded {
  opacity: 1;
}

.image-container.loaded .image-loading-placeholder {
  opacity: 0;
  pointer-events: none;
}

/* Loading Styles */
.image-loading-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(45deg, #1a1a1a, #2a2a2a);
  color: #DF4818;
  font-size: 14px;
  z-index: 2;
  transition: opacity 0.3s ease;
}

.swiper-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  background: linear-gradient(45deg, #1a1a1a, #2a2a2a);
  border-radius: 15px;
  color: #DF4818;
  font-size: 16px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #444;
  border-top: 4px solid #DF4818;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 991.98px) {
  .mobile-swiper .image-loading-placeholder span {
    font-size: 12px;
  }

  .mobile-swiper .loading-spinner {
    width: 30px;
    height: 30px;
    border-width: 3px;
  }
}

/* Content Sections */
.content-sections {
  padding: 20px;
}

@media (max-width: 991.98px) {
  .content-sections {
    padding: 0;
  }
}

.section-container {
  margin-bottom: 40px;
  background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
  border-radius: 15px;
  padding: 20px;
  border: 1px solid #444;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.section-title {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: -10px;
  /* margin-bottom: 20px;
  text-align: center; */
  text-shadow: 0 0 10px #DF4818;
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  min-height: 100px;
}

/* Footer */
.footer-container {
  margin-top: 50px;
}

/* Responsive Adjustments */
@media (max-width: 991.98px) {
  .mobile-layout {
    padding-top: 105px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-container .game-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }

  .menu-text {
    font-size: 10px;
  }

  .menu-icon {
    width: 60px;
    height: 60px;
  }
}

/* Mobile Announcement Modal - centered, content-based height */
@media (max-width: 575.98px) {
  #ads-no-show-again.modal.show {
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding: 20px !important;
  }

  #ads-no-show-again .modal-dialog {
    margin: 0;
    max-width: calc(100% - 40px);
    width: 100%;
    height: auto;
  }

  #ads-no-show-again .modal-content {
    min-height: auto;
    max-height: calc(100vh - 40px);
    border-radius: 12px;
    overflow: hidden;
  }

  #ads-no-show-again .modal-body {
    overflow-y: auto;
    max-height: calc(100vh - 150px);
  }

  #ads-no-show-again img.img-fluid {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}
</style>
